import React, { FC } from 'react';
import 'whatwg-fetch';
import { Box, Grid, Typography } from '@material-ui/core';
import useEmployeeEvents from '../../hooks/useEmployeeEvents';
import FeedEvent from './components/FeedEvent';
import FeedEventLoader from './components/FeedEventLoader';
import Button from 'src/components/Button';
import { MdRefresh as RefreshIcon } from '@react-icons/all-files/md/MdRefresh';

interface Props {
  employeeId?: string;
}

const Feed: FC<Props> = ({ employeeId }) => {
  const { events, total, loading, refresh } = useEmployeeEvents(employeeId);

  return (
    <Grid container spacing={2}>
      <Box display='flex' justifyContent='space-between' alignItems='center' clone>
        <Grid item xs={12}>
          <Box fontWeight='bolder' fontSize='17px' ml={1}>
            Flux d'activité
          </Box>
          <Button variant='outlined' startIcon={<RefreshIcon />} color='primary' onClick={refresh}>
            Actualiser
          </Button>
        </Grid>
      </Box>

      {loading && (
        <Grid item xs={12}>
          <FeedEventLoader />
        </Grid>
      )}

      {events.map((event) => (
        <Grid item xs={12} key={event.id}>
          <FeedEvent event={event} />
        </Grid>
      ))}

      {total <= 0 && (
        <Grid item xs={12}>
          <Box mt='50px' display='flex' flexDirection='column' alignItems='center'>
            <Typography variant='h6'>Aucun évènement</Typography>
            <Box color='text.disabled' clone>
              <Typography variant='caption'>Vous n'avez reçu aucune évaluation cliente ...</Typography>
            </Box>
          </Box>
        </Grid>
      )}

      {total - events.length > 0 && (
        <Box mt='10px !important' textAlign='center' clone>
          <Grid item xs={12}>
            {total - events.length} évènements supplémentaires
          </Grid>
        </Box>
      )}
    </Grid>
  );
};

export default Feed;
